<div class="container my-4">
  <div class="content-wrapper col-lg-10 col-sm-11 mx-auto">
    @if (farmOutForm && farmOut && farmOut.id) {
      <h3 class="text-center text-uppercase">{{ title | async }} <strong > {{ farmOut.status }}</strong></h3>
    }
    <hr class="mb-4">
    @if (loadingDetails | async) {
      <div class="text-center">
        <h3 class="mb-3">Cargando...</h3>
        <div class="d-flex justify-content-center">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    }
    <button  mat-raised-button (click)="onNoClick()">{{'Close' | translate}}</button>
    @if (!(loadingDetails | async)) {
      <div>
        <p [innerHTML]="result | translate"></p>
        <p [innerHTML]="summary | translate"></p>
        @if (farmOutForm && farmOut && farmOut.id) {
          <form [formGroup]="farmOutForm"  >
            @if (!result || !farmOut) {
              <div>
              <div class="mb-4">
                <h4 class="fw-bold">Job Details</h4>
                <div class="row mb-2">
                  <div class="col-sm-6">
                    <h5>Our Ref: {{ farmOut.ourRef || 'Pending' }} </h5>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-sm-6">
                    <strong>Affiliate Name:</strong> {{ farmOut.affiliateName }}
                  </div>
                  <div class="col-sm-6">
                    <strong>City:</strong> {{ farmOut.ciudad }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-sm-6">
                    <strong>Date:</strong> {{ farmOut.fecha }}
                  </div>
                  <div class="col-sm-6">
                    <strong>Time:</strong> {{ farmOut.hora }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-sm-6">
                    <strong>Vehicle Category:</strong> {{ farmOut.vehicleCategory }}
                  </div>
                  @if (farmOut.vehicleCategoryDescription) {
                    <div class="col-sm-6" >
                      <strong>Vehicle Category Description:</strong> {{ farmOut.vehicleCategoryDescription }}
                    </div>
                  }
                </div>
                @if (farmOut.recogida) {
                  <div class="row mb-2" >
                    <div class="col">
                      <strong>Pick-up:</strong> {{ farmOut.recogida }}
                    </div>
                  </div>
                }
                @if (farmOut.destino) {
                  <div class="row mb-2" >
                    <div class="col">
                      <strong>Destination:</strong> {{ farmOut.destino }}
                    </div>
                  </div>
                }
                @if (farmOut.paradas && farmOut.paradas.length) {
                  <div class="row mb-2" >
                    <div class="col">
                      <strong>Stops:</strong>
                      <ul class="list-group list-group-flush">
                        @for (stop of farmOut.paradas; track stop) {
                          <li class="list-group-item" >{{ stop }}</li>
                        }
                      </ul>
                    </div>
                  </div>
                }
                @if (farmOut.instrucciones) {
                  <div class="row mb-2" >
                    <div class="col">
                      <strong>Instructions:</strong> {{ farmOut.instrucciones }}
                    </div>
                  </div>
                }
              </div>

              <div class="mb-4">
                <h4 class="fw-bold">Price Quote</h4>
                <div class="mb-2">
                  <label class="form-label">All Inclusive Price Quote:</label>
                  <input matInput  appCurrencyFormatter class="form-control" [(ngModel)]="farmOut.allInclusivePrice" [disabled]="quoteLocked | async" [ngModelOptions]="{standalone: true, name : 'price'}"/>
                </div>
                <div class="mb-2">
                  <label class="form-label">Additional Hour Price:</label>
                  <input matInput  appCurrencyFormatter class="form-control" [(ngModel)]="farmOut.aditionalHourPrice" [disabled]="quoteLocked | async"  [ngModelOptions]="{standalone: true, name : 'hour'}">
                </div>
                <div class="mb-2">
                  <label class="form-label">Currency:</label>
                  <mat-select class="form-control" [(ngModel)]="farmOut.currency"  [ngModelOptions]="{standalone: true}"  [disabled]="quoteLocked | async">
                    <mat-option  value="COP">COP</mat-option>
                    <mat-option  value="USD">USD</mat-option>
                  </mat-select>
                </div>
              </div>

              <div>
                <h4 class="fw-bold">Driver Information</h4>
                <ng-select [items]="drivers | async"
                           bindLabel="fullName"
                           [disabled]="(asignationLocked | async)"
                           [ngModelOptions]="{standalone: true}"
                           (change)="driverSelect()"
                           [(ngModel)]="driver">
                </ng-select>
                <div class="mb-2">
                  <label class="form-label">Driver Name:</label>
                  <input type="text" class="form-control" [(ngModel)]="farmOut.driverName" [disabled]="(asignationLocked | async) || farmOut.driverId != null" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="mb-2">
                  <label class="form-label">Driver Phone:</label>
                  <div class="input-group">
                    <ngx-intl-tel-input
                      style=" color: #000000"
                      [cssClass]="'custom'"
                      [preferredCountries]="[ CountryISO.Colombia, CountryISO.Brazil, CountryISO.France, CountryISO.Germany, CountryISO.UnitedStates]"
                      [enableAutoCountrySelect]="true"
                      [enablePlaceholder]="true"
                      [searchCountryFlag]="true"
                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                      [selectFirstCountry]="false"
                      [selectedCountryISO]="CountryISO.Colombia"
                      [maxLength]="17"
                      [phoneValidation]="true"
                      [separateDialCode]="true"
                      [id]="'driverPhone'"
                      formControlName="driverPhone"
                    ></ngx-intl-tel-input>
                    <div class="invalid-feedback">
                      {{'ContactFormError-3' | translate}}
                    </div>
                  </div>
                </div>
              </div>

              <div >
                <h4 class="fw-bold">Vehicle Information</h4>
                <ng-select [items]="vehicles | async"
                           bindLabel="fullName"
                           [disabled]="(asignationLocked | async)"
                           [ngModelOptions]="{standalone: true}"
                           (change)="vehicleSelect()"
                           [(ngModel)]="vehicle">
                </ng-select>
                <div class="mb-2">
                  <label class="form-label">Vehicle Plate:</label>
                  <input type="text" class="form-control" [(ngModel)]="farmOut.vehiclePlate"
                         oninput="this.value = this.value.toUpperCase()"
                         [disabled]="(asignationLocked | async) || farmOut.vehicleId != null" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="mb-2">
                  <label class="form-label">Vehicle Make/Model:</label>
                  <input type="text" class="form-control" [(ngModel)]="farmOut.vehicleMakeModel" [disabled]="(asignationLocked | async) || farmOut.vehicleId != null" [ngModelOptions]="{standalone: true}"/>
                </div>
                <div class="mb-2">
                  <label class="form-label">Vehicle Year:</label>
                  <input type="text" class="form-control" [(ngModel)]="farmOut.vehicleYear" [disabled]="(asignationLocked | async) || farmOut.vehicleId != null" [ngModelOptions]="{standalone: true}"/>
                </div>
              </div>

              <div class="mb-4">
                <h4 class="fw-bold">Confirmation Details</h4>
                <div class="mb-2">
                  <label class="form-label">Operator Ref:</label>
                  <input type="text" class="form-control" [(ngModel)]="farmOut.operatorRef" [disabled]="(refLocked | async)" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="mb-2">
                  <label class="form-label">Your Name and Comments/Conditions:</label>
                  <textarea cols="10" rows="4" type="text" class="form-control" [(ngModel)]="farmOut.condiciones" [disabled]="asignationLocked | async" [ngModelOptions]="{standalone: true}"></textarea>
                </div>
              </div>

              @if (billingInfoLocked | async) {
                <div>
                  <h4 class="fw-bold">Billing Information</h4>
                  <div class="mb-2">
                    <label class="form-label">All Inclusive Price:</label>
                    <input type="text" class="form-control" [(ngModel)]="farmOut.allInclusivePrice" [disabled]="billingInfoLocked | async" [ngModelOptions]="{standalone: true}"/>
                  </div>
                  <div class="mb-2">
                    <label class="form-label">Additional Hour Price:</label>
                    <input type="number" class="form-control" [(ngModel)]="farmOut.aditionalHourPrice" [disabled]="billingInfoLocked | async" [ngModelOptions]="{standalone: true}"/>
                  </div>
                </div>
              }

              <div class="text-center mt-4">
                @if ( !(quoteLocked | async)) {
                  <button class="btn btn-primary me-2" (click)="quoteJob()" >Quote</button>
                }
                @if ((!(asignationLocked | async) || farmOut.operatorRef === null) && (farmOut.status=='SOLICITADO' ||farmOut.status=='COTIZADO')) {
                  <button class="btn btn-success me-2" (click)="acceptJob(true)"  >Accept</button>
                }
                @if ((!(asignationLocked | async) || farmOut.operatorRef === null) && (farmOut.status=='COTIZADO' || farmOut.status=='ACEPTADO' || farmOut.status=='ASIGNADO')) {
                  <button class="btn btn-success me-2" (click)="acceptJob(false)"  >Change Information</button>
                }
                @if (!(asignationLocked | async)) {
                  <button class="btn btn-danger me-2" (click)="rejectJob()" >Reject</button>
                }
                @if (!(billingInfoLocked | async) && (farmOut.status=='HECHO' ||farmOut.status=='ANULADO')) {
                  <button class="btn btn-warning" (click)="sendInvoice()" >Invoice</button>
                }
                @if (asignationLocked | async) {
                  <label class="form-label" >Asigned job must be cancelled by email of phone</label>
                }
              </div>
                @if (resultString !== null && resultString.length > 0) {
                  <div class="{{resultClass}} mt-3"  >
                    {{resultString}}
                  </div>
                }
            </div>
            }
          </form>
        }
      </div>
    }
  </div>
</div>
